var _path, _path2, _g, _path3, _g2, _path4, _path5, _line, _line2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginPageSideIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 771,
    height: 1024,
    viewBox: "0 0 771 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3842_2019)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H769V1024H9.99999C4.47714 1024 0 1019.52 0 1014V10Z",
    fill: "url(#paint0_linear_3842_2019)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3842_2019",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 351,
    y: 1017,
    width: 2,
    height: 5
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M352.438 1018.44C352.614 1019.4 352.755 1020.16 352.931 1021.12C352.72 1019.97 352.509 1018.82 351.972 1017.58C352.333 1017.87 352.368 1018.06 352.438 1018.44Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3842_2019)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.869 1021.07L351.802 1021.24L352.277 1017.55L353.344 1017.38L352.869 1021.07Z",
    fill: "url(#paint1_linear_3842_2019)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3842_2019",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 351,
    y: 1015,
    width: 2,
    height: 3
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M352.252 1017.67C352.109 1016.91 351.966 1016.14 351.859 1015.57C351.675 1016.23 352.109 1016.91 352.252 1017.67Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3842_2019)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.223 1017.63L351.416 1017.71L351.586 1015.49L352.393 1015.41L352.223 1017.63Z",
    fill: "url(#paint2_linear_3842_2019)"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.40186 2.69922L196.652 257.949M770.402 1023.7L386 511",
    stroke: "#BEBEBE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M386 511L1.39889 1019.57",
    stroke: "#BEBEBE"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 392.398,
    y1: 0.303439,
    x2: 195.398,
    y2: 258.303,
    stroke: "white"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 770.406,
    y1: 596.291,
    x2: 464.406,
    y2: 1023.29,
    stroke: "#BEBEBE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3842_2019",
    x1: 384.5,
    y1: 0,
    x2: 384.5,
    y2: 1024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8430D",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#621A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3842_2019",
    x1: 313.195,
    y1: 1026.78,
    x2: 172.864,
    y2: 1010.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1417,
    stopColor: "#556534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3042,
    stopColor: "#835F30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4636,
    stopColor: "#A7552C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6161,
    stopColor: "#C34628"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7599,
    stopColor: "#D83426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8916,
    stopColor: "#E62425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED1C24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3842_2019",
    x1: 313.535,
    y1: 1023.61,
    x2: 173.336,
    y2: 1007.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1417,
    stopColor: "#556534"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3042,
    stopColor: "#835F30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4636,
    stopColor: "#A7552C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6161,
    stopColor: "#C34628"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7599,
    stopColor: "#D83426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8916,
    stopColor: "#E62425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED1C24"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3842_2019"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0H769V1024H9.99999C4.47714 1024 0 1019.52 0 1014V10Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginPageSideIllustration);
export default __webpack_public_path__ + "static/media/LoginPageSideIllustration.7dfd17189fd4cf9283b85ae72bebab70.svg";
export { ForwardRef as ReactComponent };